import { render, staticRenderFns } from "./SuspendedOrBlockedBanner.vue?vue&type=template&id=36524496&"
import script from "./SuspendedOrBlockedBanner.vue?vue&type=script&lang=js&"
export * from "./SuspendedOrBlockedBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports